export const TEAM_ACTIONS = {
  SET_TEAM: 'SET_TEAM',
  DESTROY_TEAM: 'DESTROY_TEAM',
  SET_TEAM_INSTANCE: 'SET_TEAM_INSTANCE',
  SET_TEAM_INSTANCE_USERS: 'SET_TEAM_INSTANCE_USERS',
  DESTROY_TEAM_INSTANCE: 'DESTROY_TEAM_INSTANCE',
}
